<ng-container *ngIf="page_data_loaded">
	<div class="action-items-container">
		<div class="action-items-metrics-grid">
			<!-- <div class="action-items-metric-card alert">
				<div class="action-items-metric-title">Needs you today</div>
				<div class="action-items-metric-value">{{commonService.abbreviateNumber(page_data['pending_activities'])}} actions</div>
				<div class="action-items-metric-subtitle">{{page_data['pending_activities_subtitle']}}</div>
			</div>
			<div class="action-items-metric-card">
				<div class="action-items-metric-title">Value at risk today</div>
				<div class="action-items-metric-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(page_data['retention_value'])}}</div>
				<div class="action-items-metric-subtitle">{{page_data['retention_value_subtitle']}}</div>
			</div>
			<div class="action-items-metric-card">
				<div class="action-items-metric-title">Open pipeline</div>
				<div class="action-items-metric-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(page_data['opportunity_value'])}}</div>
				<div class="action-items-metric-subtitle">{{page_data['opportunity_value_subtitle']}}</div>
			</div>
			<div class="action-items-metric-card success">
				<div class="action-items-metric-title">Completed this week</div>
				<div class="action-items-metric-value">{{commonService.abbreviateNumber(page_data['completed_this_week'])}}</div>
				<div class="action-items-metric-subtitle">{{page_data['completed_this_week_subtitle']}}</div>
			</div> -->

			<div class="action-items-metric-card" *ngFor="let summary of page_data; let isFirst = first; let isLast = last" [ngClass]="{ 'alert': isFirst, 'success': isLast }">
				<div class="action-items-metric-title">{{summary.label}}</div>
				<div class="action-items-metric-value">
					<span *ngIf="summary.symbol">{{APP_CONSTANTS.CURRENCY_SYMBOL}}</span>
					<span *ngIf="!summary.format">{{summary['value']}}</span>
					<span *ngIf="summary.format">{{commonService.abbreviateNumber(summary['value'])}}</span>
				</div>
				<div class="action-items-metric-subtitle">{{summary['description']}}</div>
			</div>

		</div>

		<!-- <div class="ai-governance-section" *ngIf="(user_details.role.role == 5) || (user_details.role.role == 6)">
			<span class="ai-governance-heading">AI Governance - Engagement Dashboard</span>
			<button class="ai-governance-action" (click)="navigateToAIGovernance()">View Dashboard</button>
		</div> -->

		<!-- <ng-container *ngIf="top_action_data.length > 0">
			<div class="top-action-heading-section">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24" height="24">
					<path fill="currentColor" d="M116.3 301.7L254.1 113.6c5.8-7.9 17.6-6.4 21.1 2.9l40.1 106.8h112.5c10.3 0 16.2 12 9.7 20.1L295.7 398.4c-5.8 7.2-16.7 5.6-20.4-2.7l-47.3-105.8H122.2c-10.4 0-16.3-12.1-9.9-20.2z"/>
				</svg>
				<span>Start Here</span>
			</div>

			<div class="top-action-section" *ngFor="let activity of top_action_data">
				<div class="top-action-header">
					<span class="best-action-heading">Next best action</span>
					<div class="action-due-section">
						<div class="action-due-dot"></div>
						<span>{{activity.due}}</span>
					</div>
				</div>

				<p class="top-action-text">{{activity.title}}</p>

				<div class="top-action-user-details-section">
					<div class="each-top-action-details">
						<div class="each-top-action-details-label">{{activity.type}}</div>
						<div class="each-top-action-details-val">{{activity.name}}</div>
					</div>
					<div class="each-top-action-details">
						<div class="each-top-action-details-label">Opportunity</div>
						<div class="each-top-action-details-val">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(activity.opportunity)}}</div>
					</div>
					<div class="each-top-action-details">
						<div class="each-top-action-details-label">Stage</div>
						<div class="each-top-action-details-val">{{activity.stage}}</div>
					</div>
				</div>

				<div class="top-action-step-section">
					<div class="top-action-next-step-label">Suggested next step</div>
					<div class="top-action-next-step-text">{{activity.suggested_next_step}}</div>
				</div>

				<div class="top-step-actions">
					<button class="top-primary-action" (click)="topTaskAction(activity)" *ngIf="activity.action_value != ''">
						Commented
						<img [src]="activity.show_icon" class="top-primary-action-icon" />
						{{activity.action_text}}
					</button>
					<span class="top-primary-action" *ngIf="activity.action_value == ''" style="opacity: 0.5; cursor: none;">{{activity.action_text}}</span>
					<button class="top-secondary-action" (click)="markDone(activity)">Mark done</button>
				</div>
			</div>
		</ng-container> -->


		<div class="list-header-row">
			<h3 class="list-title">Up next</h3>
			<div class="filter-group">
				<!-- <div class="search-wrapper">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="1em" height="1em">
						<path fill="currentColor" d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.1-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
					</svg>
					<input type="text" class="search-input" placeholder="Search name or email" [(ngModel)]="action_items_search" (ngModelChange)="searchSubject.next($event)" />
				</div> -->
				<div class="filter-tabs">
					<button class="filter-tab" [ngClass]="{'active': action_items_duration == 'All'}" (click)="segregateActionItemsDuration('All')">All</button>
					<button class="filter-tab" [ngClass]="{'active': action_items_duration == 'Today'}" (click)="segregateActionItemsDuration('Today')">Do now</button>
					<button class="filter-tab" [ngClass]="{'active': action_items_duration == 'Week'}" (click)="segregateActionItemsDuration('Week')">This week</button>
					<button class="filter-tab" [ngClass]="{'active': action_items_duration == 'Schedule'}" (click)="segregateActionItemsDuration('Schedule')">Scheduled</button>
					<button class="filter-tab" [ngClass]="{'active': action_items_duration == 'Governance'}" (click)="segregateActionItemsDuration('Governance')">Governance</button>
				</div>
				<div class="schedule-section" *ngIf="action_items_duration == 'Schedule'">
					<input
						type="text"
						class="schedule-input"
						bsDaterangepicker
						placement="left"
						[(ngModel)]="action_items_date"
						(bsValueChange)="onDateRangeChange($event)"
						[bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
					/>
				</div>
			</div>
		</div>
		<ng-container *ngIf="action_items_data_loaded">
			<div class="task-list">
				<!-- <ng-container *ngIf="action_items_data.length > 0">
					<div class="task-item" *ngFor="let task of action_items_data" [style.borderLeftColor]="task.background_color">
						<div class="task-left">
							<div class="task-icon">
								<img [src]="task.show_icon" class="top-primary-action-icon" />
							</div>
							<div class="task-info">
								<h4>{{task.title}}</h4>
								<div class="task-meta">
									<span>{{task.name}}</span>
									<span>•</span>
									<span>{{task.stage}}</span>
									<span>•</span>
									<span>20 min</span>
								</div>
							</div>
						</div>
						<div class="task-right">
							<div class="task-amount">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(task.opportunity)}}</div>
							<span class="badge" [style.background]="task.background_color">
								<span class="badge-dot" [style.background]="task.color"></span>
								<span [style.color]="task.color">{{task.due}}</span>
							</span>
							<button class="view-action-button" (click)="viewIndividualActivity(task)" *ngIf="task.type != 'engagement'">Take Action &rarr;</button>
							<button class="view-action-button" (click)="openGroupedActivity(task)" *ngIf="task.type == 'engagement'">Review & Act &rarr;</button>
						</div>
					</div>
				</ng-container> -->

				<ng-container *ngIf="action_items_data.length > 0">
					<div class="task-card" *ngFor="let task of action_items_data" (click)="viewTaskDetails(task)">
						<div class="task-card-left">
							<div class="task-card-header">
								<h3 class="task-card-name">{{task.name}}</h3>
								<!-- <span class="badge client">{{task.type}}</span> -->
								<span class="badge client">{{task.type_label}}</span>
							</div>
							<div class="task-card-description">
								<svg class="target-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
									<circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="4"/>
								</svg>
								<span>{{task.title}}</span>
							</div>
						</div>
						<div class="task-card-right">
							<div class="meta-item">
								<span class="meta-label">OPPORTUNITY</span>
								<span class="meta-value green">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(task.opportunity)}}</span>
							</div>
							<div class="meta-item">
								<!-- <span class="meta-label" *ngIf="task.type != 'engagement'">TIME TO CLOSE</span> -->
								<span class="meta-label" *ngIf="task.type != 'engagement'">DUE</span>
								<span class="meta-label" *ngIf="task.type == 'engagement'">SEGMENT</span>
								<span class="meta-value yellow">
									<svg class="clock-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
										<circle cx="12" cy="12" r="10"/>
										<polyline points="12 6 12 12 16 14"/>
									</svg>
									{{task.due}}
								</span>
							</div>
							<button class="arrow-btn" aria-label="View details">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
									<line x1="5" y1="12" x2="19" y2="12"/>
									<polyline points="12 5 19 12 12 19"/>
								</svg>
							</button>
						</div>
					</div>
				</ng-container>

				<ng-container *ngIf="action_items_data.length == 0">
					<h1 class="list-title" style="text-align: center;">No Data Found</h1>
				</ng-container>
    		</div>
		</ng-container>

		<ng-container *ngIf="!action_items_data_loaded">
			<app-loader [loading_text]="'Loading Action Items'"></app-loader>
		</ng-container>

	</div>
</ng-container>

<ng-container *ngIf="!page_data_loaded">
	<app-loader [loading_text]="'Loading Action Items'"></app-loader>
</ng-container>


<ng-container *ngIf="show_grouped_action_item">
	<div class="grouped-activity-bg-section">
		<div class="grouped-activity-section">
			<div class="grouped-activity-heading-section">
				<div>
					<p class="grouped-activity-header-top-tag">Grouped Action Item &middot; {{show_grouped_action_item_meta_data.name}}</p>
					<p class="grouped-activity-header-title">{{show_grouped_action_item_meta_data.title}}</p>
					<p class="grouped-activity-header-subtitle">{{show_grouped_action_item_meta_data.sub_title}}</p>
				</div>
				<div class="grouped-activity-header-action-section">
					<span class="grouped-activity-close-icon" (click)="closeGroupedActivity()">&times;</span>
				</div>
			</div>
			<div class="grouped-activity-content-section">
				<ng-container *ngIf="grouped_action_item_data_loaded">
					<ng-container *ngIf="!show_email_input_section">
						<div class="grouped-activity-filter-section">
							<div class="grouped-activity-filter-row">
								<span class="grouped-activity-filter-label">Segment:</span>

								<button class="grouped-activity-chip" *ngFor="let segment of grouped_action_item_data['segments']" [ngClass]="{'active': grouped_action_item_segement == segment.key}" (click)="grouped_action_item_segement = segment.key; getGroupedActionItemData();">{{segment.value}} ({{commonService.abbreviateNumber(segment.count)}})</button>

								<!-- <button class="grouped-activity-chip active">All (24)</button>
								<button class="grouped-activity-chip">Top 25% AI Scored (12)</button>
								<button class="grouped-activity-chip">High AUM Potential (12)</button>
								<button class="grouped-activity-chip">Contacted Once (12)</button>
								<button class="grouped-activity-chip">Contacted Multiple Times (12)</button>
								<button class="grouped-activity-chip grouped-activity-chip-sub">No Response for 7+ Days (12)</button>
								<button class="grouped-activity-chip grouped-activity-chip-sub">No Response for 14+ Days (12)</button> -->
							</div>
						</div>

						<div class="grouped-activity-table-responsive">
							<table>
								<thead>
									<tr>
										<th style="width: 40px;">
											<mat-checkbox [checked]="is_selected" (change)="selectAll($event)"></mat-checkbox>
										</th>
										<th>Name</th>
										<th>AI Score</th>
										<th>AUM / Potential</th>
										<th>Stage</th>
										<th>Last Contact</th>
										<th>Signal</th>
									</tr>
								</thead>
								<tbody  *ngIf="grouped_action_item_data['table'].length > 0">
									<tr *ngFor="let data of grouped_action_item_data['table']">
										<td>
											<mat-checkbox [checked]="checkIndividualSelection(data)" (change)="selectIndividual($event, data)"></mat-checkbox>
										</td>
										<td>
											<div class="prospect-cell">
												<div class="avatar">{{data.short_name}}</div>
												<span>{{data.name}}</span>
											</div>
										</td>
										<td>
											<!-- <span class="ai-score high">↗ 46</span> -->
											<span class="ai-score">{{data.ai_score}}</span>
										</td>
										<td>{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(data.potential_opportunity)}}</td>
										<td>{{data.stage}}</td>
										<td>{{data.last_contact}} Day(s)</td>
										<td>
											<!-- <span class="signal alert">↩ Opened but no reply</span> -->
											<span class="signal">{{data.signal}}</span>
										</td>
									</tr>
								</tbody>
								<tbody  *ngIf="grouped_action_item_data['table'].length == 0">
									<tr>
										<td colspan="7" style="text-align: center;">
											<span class="signal">No Data Found</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</ng-container>
					<div class="email-input-section" *ngIf="show_email_input_section">
						<div>
							<span class="back-link" (click)="show_email_input_section = false;">Back</span>
						</div>
						<div class="form-group half-input">
							<label class="form-label">Scheduled Date *</label>
							<input
								type="text"
								class="custom-input"
								bsDatepicker
								[minDate]="current_date"
								[(ngModel)]="email_data.scheduled_date"
								[bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
								[ngClass]="{'input-error': email_data_errors.scheduled_date}"
							/>
							<p class="error" *ngIf="email_data_errors.scheduled_date">Scheduled Date is Required.</p>
						</div>

						<!-- Subject -->
						<div class="form-group half-input">
							<label class="form-label">Subject *</label>
							<input type="text" class="custom-input" [(ngModel)]="email_data.subject" [ngClass]="{'input-error': email_data_errors.subject}" />
							<p class="error" *ngIf="email_data_errors.subject">Subject is Required.</p>
						</div>

						<!-- Email Body -->
						<div class="form-group">
							<label class="form-label">Email Body *</label>
							<angular-editor [placeholder]="'Enter text here...'" [(ngModel)]="email_data.email_body" [config]="editorConfig" [ngClass]="{'input-error': email_data_errors.email_body}"></angular-editor>
							<p class="error" *ngIf="email_data_errors.email_body">Email Body is Required.</p>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf="!grouped_action_item_data_loaded">
					<app-loader [loading_text]="'Loading'"></app-loader>
				</ng-container>
			</div>
			<div class="grouped-activity-footer-section">
				<div class="grouped-activity-footer-actions">
					<div class="bulk-footer-actions">
						<div class="grouped-activity-footer-info">
							<!-- <span *ngIf="selected_grouped_action_item_data.length > 0">No selection — actions apply to all <strong>24</strong> shown</span> -->
							<span *ngIf="selected_grouped_action_item_data.length > 0">Take Action on <strong>{{selected_grouped_action_item_data.length}}</strong> Selected</span>
						</div>
						<div>
							<ng-container *ngIf="show_email_input_section">
								<button class="grouped-activity-footer-action grouped-activity-footer-action-primary" (click)="validateEmailBulkAction()">Send Email</button>
							</ng-container>
							<ng-container *ngIf="!show_email_input_section">
								<span class="error" *ngIf="selection_error && selected_grouped_action_item_data.length == 0">Select a record to perform action</span>
								<button class="grouped-activity-footer-action grouped-activity-footer-action-primary" (click)="save('email')">Send Follow-up Email</button>
								<button class="grouped-activity-footer-action" (click)="save('call')">Call</button>
								<button class="grouped-activity-footer-action" (click)="save('meeting')">Schedule Follow-up</button>
								<button class="grouped-activity-footer-action" (click)="save('continue_nurturing')">Continue AI Nurturing</button>
							</ng-container>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>